import { useState } from 'react';

// SearchIntegrationCheckbox component
const SearchIntegrationCheckbox = ({ isChecked, isSearchDisabled, onChange }) => {
  return (
    <div className="mt-4 mb-6 p-3 bg-blue-50 border border-blue-100 rounded-md">
      <div className="flex items-center">
        <input
          type="checkbox"
          id="search-integration"
          checked={isChecked}
          disabled={isSearchDisabled}
          onChange={(e) => onChange(e.target.checked)}
          className="w-4 h-4 mr-2 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
        />
        <label htmlFor="search-integration" className="text-gray-700 font-medium">
          Include search results
          {/* <span className="ml-2 bg-blue-500 text-white text-xs px-2 py-0.5 rounded font-bold">
            PRO! COMING SOON
          </span> */}
        </label>
      </div>
      <p className="text-gray-500 text-sm mt-1 ml-6">
        Adds real-world context and up-to-date information to your data, ideal for datasets involving facts.
      </p>
    </div>
  );
};

export default SearchIntegrationCheckbox;